(ns common.schema.entities.workspace.kyc.questions.pep
  (:require
   [common.country :as country]))

(def pep-relationship-options
  [{:key :self
    :translations {:en "The person herself / himself is a PEP"
                   :fi "Henkilö itse"}}
   {:key :family-member
    :translations {:en "Family member"
                   :fi "Perheenjäsen"}}
   {:key :other
    :translations {:en "Other"
                   :fi "Muu"}}])

(def all-questions
  {:kyc-ubo.pep/name {:data/type        :data.type/text-simple
                      :mandatory-field? (fn [_answers kyc-process]
                                          (not= (:kyc-process/status kyc-process)
                                                :kyc-process.status/draft))
                      :translations     {:en "Full name of the person related to the investor"
                                         :fi "Sijoittajaan liittyvän henkilön koko nimi"}}
   :kyc-ubo.pep/first-name {:data/type        :data.type/text-simple
                            :mandatory-field? (fn [_answers kyc-process]
                                                (not= (:kyc-process/status kyc-process)
                                                      :kyc-process.status/draft))
                            :translations     {:en "First name"
                                               :fi "Etunimi"}}
   :kyc-ubo.pep/middle-names {:data/type    :data.type/text-simple
                              :translations {:en "Middle names"
                                             :fi "Toiset nimet"}}
   :kyc-ubo.pep/last-name {:data/type        :data.type/text-simple
                           :mandatory-field? (fn [_answers kyc-process]
                                               (not= (:kyc-process/status kyc-process)
                                                     :kyc-process.status/draft))
                           :translations     {:en "Last name"
                                              :fi "Sukunimi"}}
   :kyc-ubo.pep/entity-representative-name {:data/type        :data.type/text-simple
                                            :mandatory-field? (fn [_answers kyc-process]
                                                                (not= (:kyc-process/status kyc-process)
                                                                      :kyc-process.status/draft))
                                            :translations     {:en "The full name of person related to the representative of Legal entity"
                                                               :fi "Oikeushenkilön edustajaan liittyvän henkilön koko nimi"}}
   :kyc-ubo.pep/connection-to-investor {:data/type        :data.type/text-simple
                                        :mandatory-field? (fn [_answers kyc-process]
                                                            (not= (:kyc-process/status kyc-process)
                                                                  :kyc-process.status/draft))
                                        :translations     {:en "Connection to the investor"
                                                           :fi "Suhde sijoittajaan"}}
   :kyc-ubo.pep/connection-to-entity {:data/type        :data.type/text-simple
                                      :mandatory-field? (fn [_answers kyc-process]
                                                          (not= (:kyc-process/status kyc-process)
                                                                :kyc-process.status/draft))
                                      :translations     {:en "Connection to the representative of Legal entity"
                                                         :fi "Suhde oikeushenkilön edustajaan"}}
   :kyc-ubo.pep/relationship-to-pep {:data/type        :data.type/keyword
                                     :mandatory-field? (fn [_answers kyc-process]
                                                         (not= (:kyc-process/status kyc-process)
                                                               :kyc-process.status/draft))
                                     :options          [{:key :self
                                                         :translations {:en "The person herself / himself is a PEP"
                                                                        :fi "Henkilö itse"}}
                                                        {:key :related-person
                                                         :translations {:en "Relative or an associate"
                                                                        :fi "Läheinen tai lähipiiriin kuuluva henkilö"}}]
                                     :translations     {:en "Relationship to PEP"
                                                        :fi "Suhde poliittisesti vaikutusvaltaiseen henkilöön"}}
   :kyc-ubo.pep/relationship-to-ubo {:data/type         :data.type/keyword
                                     :mandatory-field?  (fn [_answers kyc-process]
                                                          (not= (:kyc-process/status kyc-process)
                                                                :kyc-process.status/draft))
                                     :options           pep-relationship-options
                                     :conditional-field (fn [answers]
                                                          (= :yes (:kyc-ubo/pep answers)))
                                     :translations      {:en "Relationship to UBO"
                                                         :fi "Suhde tosiasialliseen edunsaajaan"}}
   :kyc-ubo.pep/related-person-name {:data/type         :data.type/text-simple
                                     :mandatory-field?  (fn [_answers kyc-process]
                                                          (not= (:kyc-process/status kyc-process)
                                                                :kyc-process.status/draft))
                                     :conditional-field (fn [answers]
                                                          (= :related-person (:kyc-ubo.pep/relationship-to-pep answers)))
                                     :translations      {:en "The full name of the relative or associate"
                                                         :fi "Läheisen tai lähipiiriin kuuluvan henkilön koko nimi"}}
   :kyc-ubo.pep/country {:data/type        :data.type/keyword
                         :mandatory-field? (fn [_answers kyc-process]
                                             (not= (:kyc-process/status kyc-process)
                                                   :kyc-process.status/draft))
                         :options          country/options
                         :translations     {:en "Country where politically exposed"
                                            :fi "Maa, jossa poliittisesti vaikutusvaltainen"}}
   :kyc-ubo.pep/political-function {:data/type        :data.type/text-simple
                                    :mandatory-field? (fn [_answers kyc-process]
                                                        (not= (:kyc-process/status kyc-process)
                                                              :kyc-process.status/draft))
                                    :translations     {:en "Political function"
                                                       :fi "Virka"}}

   :kyc-ubo.pep/dob {:data/type        :data.type/date
                     :mandatory-field? (fn [_answers kyc-process]
                                         (not= (:kyc-process/status kyc-process)
                                               :kyc-process.status/draft))
                     :translations     {:en "Date of birth"
                                        :fi "Syntymäaika"}}

   :kyc-ubo.pep/birth-country {:data/type        :data.type/keyword
                               :mandatory-field? (fn [_answers kyc-process]
                                                   (not= (:kyc-process/status kyc-process)
                                                         :kyc-process.status/draft))
                               :options          country/options
                               :translations     {:en "Birth country"
                                                  :fi "Syntymämaa"}}})
